import axios from 'axios'

const performGet = async (url) => {
  return axios.get(url).then((res) => res.data)
}

const performGetWithQueryParam = async (url, params) => {
  const axiosRequestConfig = { params }

  return axios.get(url, axiosRequestConfig).then((res) => res.data)
}

const performGetFile = async (url) => {

  return axios
    .get(url, {
      responseType: 'blob',
    })
    .then((res) => res.data)
}

export const HttpUtil = {
  performGet,
  performGetWithQueryParam,
  performGetFile,
}
